import { SELECTED_TAB } from "../actions/types";

const initialState = {
  selected: 3,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_TAB:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
